/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ResponderModel } from '../models/responder-model';
import { FindFilter } from '../models/find-filter';
import { SpecialistQueryModel } from '../models/specialist-query-model';
import { ResponderOrganizationTeamsModel } from '../models/responder-organization-teams-model';
import { AdminOfficerModel } from '../models/admin-officer-model';
import { LookupValueModel } from '../models/lookup-value-model';
import { ImageUploadResultModel } from '../models/image-upload-result-model';
import { ImageModel } from '../models/image-model';
import { UserModel } from 'projects/rms/app/api/models/user-model';
@Injectable({
  providedIn: 'root',
})
class ResponderService extends __BaseService {
  static readonly EmailAddressesPath = '/view/rms/responder/EmailAddresses';
  static readonly FindInDomainPath = '/view/rms/responder/FindInDomain';
  static readonly FindSpecialistPath = '/view/rms/responder/FindSpecialist';
  static readonly GetOrganizationTeamsPath = '/view/rms/responder/GetOrganizationTeams';
  static readonly GetRelIdStatusPath = '/view/rms/responder/GetRelIdStatus';
  static readonly CreateRelUserPath = '/view/rms/responder/CreateRelUser';
  static readonly GetJpatsUserStatusPath = '/view/rms/responder/GetJpatsUserStatus';
  static readonly CreateJpatsUserPath = 'view/rms/responder/CreateJpatsUser';
  static readonly GetRespondersPath = '/view/rms/responder/GetResponders';
  static readonly GetTeamAdministrativeOfficersPath = '/view/rms/responder/GetTeamAdministrativeOfficers';
  static readonly LookupsPath = '/view/rms/responder/Lookups';
  static readonly ReassignResponderPath = '/view/rms/responder/ReassignResponder';
  static readonly RespondersByUserNamePath = '/view/rms/responder/RespondersByUserName';
  static readonly SaveImagePath = '/view/rms/responder/{responderId}/SaveImage';
  static readonly SearchResponderPath = '/view/rms/responder/SearchResponder';
  static readonly UpdatePath = '/view/rms/responder';
  static readonly AddPath = '/view/rms/responder';
  static readonly DeletePath = '/view/rms/responder';
  static readonly UploadImagePath = '/view/rms/responder/{responderId}/UploadProfileImage';
  static readonly DistinctStringLookupsPath = '/view/rms/responder/DistinctStringLookups';
  static readonly GetAllDomainPath = '/view/rms/responder/AllDomain';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param obj undefined
   * @return Success
   */
  EmailAddressesResponse(obj?: ResponderModel): __Observable<__StrictHttpResponse<ResponderModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = obj;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/view/rms/responder/EmailAddresses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponderModel>;
      })
    );
  }
  /**
   * @param obj undefined
   * @return Success
   */
  EmailAddresses(obj?: ResponderModel): __Observable<ResponderModel> {
    return this.EmailAddressesResponse(obj).pipe(
      __map(_r => _r.body as ResponderModel)
    );
  }

  /**
   * @param findFilter undefined
   * @return Success
   */
  FindInDomainResponse(findFilter?: FindFilter): __Observable<__StrictHttpResponse<Array<ResponderModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = findFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder/FindInDomain`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResponderModel>>;
      })
    );
  }
  /**
   * @param findFilter undefined
   * @return Success
   */
  FindInDomain(findFilter?: FindFilter): __Observable<Array<ResponderModel>> {
    return this.FindInDomainResponse(findFilter).pipe(
      __map(_r => _r.body as Array<ResponderModel>)
    );
  }

  /**
   * @param findFilter undefined
   * @return Success
   */
  FindSpecialistResponse(findFilter?: FindFilter): __Observable<__StrictHttpResponse<Array<SpecialistQueryModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = findFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder/FindSpecialist`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SpecialistQueryModel>>;
      })
    );
  }
  /**
   * @param findFilter undefined
   * @return Success
   */
  FindSpecialist(findFilter?: FindFilter): __Observable<Array<SpecialistQueryModel>> {
    return this.FindSpecialistResponse(findFilter).pipe(
      __map(_r => _r.body as Array<SpecialistQueryModel>)
    );
  }

  /**
   * @param userName undefined
   * @return Success
   */
  GetOrganizationTeamsResponse(userName?: string): __Observable<__StrictHttpResponse<ResponderOrganizationTeamsModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userName != null) __params = __params.set('userName', userName.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder/GetOrganizationTeams`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponderOrganizationTeamsModel>;
      })
    );
  }
  /**
   * @param userName undefined
   * @return Success
   */
  GetOrganizationTeams(userName?: string): __Observable<ResponderOrganizationTeamsModel> {
    return this.GetOrganizationTeamsResponse(userName).pipe(
      __map(_r => _r.body as ResponderOrganizationTeamsModel)
    );
  }

  /**
   * @param responderId undefined
   * @return Success
   */
  GetRelIdStatusResponse(responderId?: number): __Observable<__StrictHttpResponse<Array<number>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (responderId != null) __params = __params.set('responderId', responderId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/rms/responder/GetRelIdStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<number>>;
      })
    );
  }
  /**
   * @param responderId undefined
   * @return Success
   */
  GetRelIdStatus(responderId?: number): __Observable<Array<number>> {
    return this.GetRelIdStatusResponse(responderId).pipe(
      __map(_r => _r.body as Array<number>)
    );
  }

  /**
   * @param responderId undefined
   * @return Success
   */
  CreateRelUserResponse(responderId?: number): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (responderId != null) __params = __params.set('responderId', responderId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/rms/responder/CreateRelUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param responderId undefined
   * @return Success
   */
  CreateRelUser(responderId?: number): __Observable<boolean> {
    return this.CreateRelUserResponse(responderId).pipe(
      __map(_r => _r.body as boolean)
    );
  }
  /**
   * @param responderId undefined
   * @return Success
   */
  GetJpatsUserStatusResponse(userName?: string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userName != null) __params = __params.set('userName', userName);
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/rms/responder/GetJpatsUserStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param responderId undefined
   * @return Success
   */
  GetJpatsUserStatus(userName?: string): __Observable<string> {
    return this.GetJpatsUserStatusResponse(userName).pipe(
      __map(_r => _r.body as string)
    );
  }
  /**
   * @param user undefined
   * @return Success
   */
  CreateJpatsUserResponse(user?: UserModel): __Observable<__StrictHttpResponse<UserModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = user;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder/CreateJpatsUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });
    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModel>;
      })
    );
  }
  /**
   * @param user undefined
   * @return Success
   */
  CreateJpatsUser(user: UserModel): __Observable<UserModel> {
    return this.CreateJpatsUserResponse(user).pipe(
      __map(_r => _r.body as UserModel)
    );
  }
  /**
   * @param findFilter undefined
   * @return Success
   */
  GetRespondersResponse(findFilter?: FindFilter): __Observable<__StrictHttpResponse<Array<ResponderModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = findFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder/GetResponders`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResponderModel>>;
      })
    );
  }
  /**
   * @param findFilter undefined
   * @return Success
   */
  GetResponders(findFilter?: FindFilter): __Observable<Array<ResponderModel>> {
    return this.GetRespondersResponse(findFilter).pipe(
      __map(_r => _r.body as Array<ResponderModel>)
    );
  }

  /**
   * @param teamId undefined
   * @return Success
   */
  GetTeamAdministrativeOfficersResponse(teamId?: number): __Observable<__StrictHttpResponse<Array<AdminOfficerModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = teamId;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder/GetTeamAdministrativeOfficers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AdminOfficerModel>>;
      })
    );
  }
  /**
   * @param teamId undefined
   * @return Success
   */
  GetTeamAdministrativeOfficers(teamId?: number): __Observable<Array<AdminOfficerModel>> {
    return this.GetTeamAdministrativeOfficersResponse(teamId).pipe(
      __map(_r => _r.body as Array<AdminOfficerModel>)
    );
  }

  /**
   * @return Success
   */
  LookupsResponse(): __Observable<__StrictHttpResponse<{[key: string]: Array<LookupValueModel>}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/rms/responder/Lookups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: Array<LookupValueModel>}>;
      })
    );
  }
  /**
   * @return Success
   */
  Lookups(): __Observable<{[key: string]: Array<LookupValueModel>}> {
    return this.LookupsResponse().pipe(
      __map(_r => _r.body as {[key: string]: Array<LookupValueModel>})
    );
  }

  /**
   * @param userName undefined
   * @return Success
   */
  ReassignResponderResponse(userName?: string): __Observable<__StrictHttpResponse<Array<ResponderModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userName != null) __params = __params.set('userName', userName.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder/ReassignResponder`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResponderModel>>;
      })
    );
  }
  /**
   * @param userName undefined
   * @return Success
   */
  ReassignResponder(userName?: string): __Observable<Array<ResponderModel>> {
    return this.ReassignResponderResponse(userName).pipe(
      __map(_r => _r.body as Array<ResponderModel>)
    );
  }

  /**
   * @param userName undefined
   * @return Success
   */
  RespondersByUserNameResponse(userName?: string): __Observable<__StrictHttpResponse<Array<ResponderModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userName != null) __params = __params.set('userName', userName.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder/RespondersByUserName`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResponderModel>>;
      })
    );
  }
  /**
   * @param userName undefined
   * @return Success
   */
  RespondersByUserName(userName?: string): __Observable<Array<ResponderModel>> {
    return this.RespondersByUserNameResponse(userName).pipe(
      __map(_r => _r.body as Array<ResponderModel>)
    );
  }

  /**
   * @param params The `ResponderService.SaveImageParams` containing the following parameters:
   *
   * - `responderId`:
   *
   * - `image`:
   *
   * @return Success
   */
  SaveImageResponse(params: ResponderService.SaveImageParams): __Observable<__StrictHttpResponse<ImageUploadResultModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.image;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder/${params.responderId}/SaveImage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ImageUploadResultModel>;
      })
    );
  }
  /**
   * @param params The `ResponderService.SaveImageParams` containing the following parameters:
   *
   * - `responderId`:
   *
   * - `image`:
   *
   * @return Success
   */
  SaveImage(params: ResponderService.SaveImageParams): __Observable<ImageUploadResultModel> {
    return this.SaveImageResponse(params).pipe(
      __map(_r => _r.body as ImageUploadResultModel)
    );
  }

  /**
   * @param findFilter undefined
   * @return Success
   */
  SearchResponderResponse(findFilter?: FindFilter): __Observable<__StrictHttpResponse<Array<ResponderModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = findFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder/SearchResponder`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResponderModel>>;
      })
    );
  }
  /**
   * @param findFilter undefined
   * @return Success
   */
  SearchResponder(findFilter?: FindFilter): __Observable<Array<ResponderModel>> {
    return this.SearchResponderResponse(findFilter).pipe(
      __map(_r => _r.body as Array<ResponderModel>)
    );
  }

  /**
   * @param obj undefined
   * @return Success
   */
  UpdateResponse(obj?: ResponderModel): __Observable<__StrictHttpResponse<ResponderModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = obj;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/view/rms/responder`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponderModel>;
      })
    );
  }
  /**
   * @param obj undefined
   * @return Success
   */
  Update(obj?: ResponderModel): __Observable<ResponderModel> {
    return this.UpdateResponse(obj).pipe(
      __map(_r => _r.body as ResponderModel)
    );
  }

  /**
   * @param obj undefined
   * @return Success
   */
  AddResponse(obj?: ResponderModel): __Observable<__StrictHttpResponse<ResponderModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = obj;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponderModel>;
      })
    );
  }
  /**
   * @param obj undefined
   * @return Success
   */
  Add(obj?: ResponderModel): __Observable<ResponderModel> {
    return this.AddResponse(obj).pipe(
      __map(_r => _r.body as ResponderModel)
    );
  }

  /**
   * @param obj undefined
   * @return Success
   */
  DeleteResponse(obj?: ResponderModel): __Observable<__StrictHttpResponse<ResponderModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = obj;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/view/rms/responder`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponderModel>;
      })
    );
  }
  /**
   * @param obj undefined
   * @return Success
   */
  Delete(obj?: ResponderModel): __Observable<ResponderModel> {
    return this.DeleteResponse(obj).pipe(
      __map(_r => _r.body as ResponderModel)
    );
  }

  /**
   * @param params The `ResponderService.UploadImageParams` containing the following parameters:
   *
   * - `responderId`:
   *
   * - `files`:
   *
   * @return Success
   */
  UploadImageResponse(params: ResponderService.UploadImageParams): __Observable<__StrictHttpResponse<ImageUploadResultModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;

    (params.files || []).forEach(val => {if (val != null) __formData.append('files', JSON.stringify(val))});
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/rms/responder/${params.responderId}/UploadProfileImage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ImageUploadResultModel>;
      })
    );
  }
  /**
   * @param params The `ResponderService.UploadImageParams` containing the following parameters:
   *
   * - `responderId`:
   *
   * - `files`:
   *
   * @return Success
   */
  UploadImage(params: ResponderService.UploadImageParams): __Observable<ImageUploadResultModel> {
    return this.UploadImageResponse(params).pipe(
      __map(_r => _r.body as ImageUploadResultModel)
    );
  }

  /**
   * @return Success
   */
  DistinctStringLookupsResponse(): __Observable<__StrictHttpResponse<{[key: string]: Array<string>}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/rms/responder/DistinctStringLookups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: Array<string>}>;
      })
    );
  }
  /**
   * @return Success
   */
  DistinctStringLookups(): __Observable<{[key: string]: Array<string>}> {
    return this.DistinctStringLookupsResponse().pipe(
      __map(_r => _r.body as {[key: string]: Array<string>})
    );
  }

  /**
   * @return Success
   */
  GetAllDomainResponse(): __Observable<__StrictHttpResponse<Array<ResponderModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/rms/responder/AllDomain`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResponderModel>>;
      })
    );
  }
  /**
   * @return Success
   */
  GetAllDomain(): __Observable<Array<ResponderModel>> {
    return this.GetAllDomainResponse().pipe(
      __map(_r => _r.body as Array<ResponderModel>)
    );
  }
}

module ResponderService {

  /**
   * Parameters for SaveImage
   */
  export interface SaveImageParams {
    responderId: number;
    image?: ImageModel;
  }

  /**
   * Parameters for UploadImage
   */
  export interface UploadImageParams {
    responderId: number;
    files?: Array<any>;
  }
}

export { ResponderService }
